import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { CustomButton, IButtonVariant } from "../../../components/CustomButton";
import { CustomModal } from "../../../components/CustomModal";
import { deleteInviteToMobileAppThunk } from "../../../reducers/collectionPointReducer";
import { getCollectionPointDetail } from "../../../selectors/collectionPoint";
import { IModal } from "../../../types/modal";

import styles from "./DeleteInviteToMobileAppModal.module.scss";

type DeleteInviteToMobileAppModal = IModal;

export const DeleteInviteToMobileAppModal: React.FC<DeleteInviteToMobileAppModal> = ({
  isModalVisible,
  toggleModalVisibility,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { locationId } = useSelector(getCollectionPointDetail);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const handleDeleteInviteToMobileAppThunk = async () => {
    setIsFetching(true);
    try {
      await dispatch(deleteInviteToMobileAppThunk(locationId));
    } catch (error) {
      console.error("Error deleting invite to mobile app:", error);
    }
    setIsFetching(false);
    toggleModalVisibility();
  };

  const handleCloseModal = () => {
    toggleModalVisibility();
  };

  return (
    <CustomModal
      isModalVisible={isModalVisible}
      toggleModalVisibility={handleCloseModal}
      title="resetAccountTitle"
      text="resetAccountDescriptionText"
    >
      <div className={styles.buttonsContainer}>
        <CustomButton
          text={t("cancel")}
          onClick={handleCloseModal}
          variant={IButtonVariant.neutral}
          disabled={isFetching}
        />
        <CustomButton text={t("resetAccount")} onClick={handleDeleteInviteToMobileAppThunk} disabled={isFetching} />
      </div>
    </CustomModal>
  );
};
